const MessageCardType = {
  whitePaper: '0',
  input: '1',
  none: '2'
};

export default MessageCardType;



// WEBPACK FOOTER //
// ./src/constants/message-card-type.js